import { Field, Model, Type } from 'serialize-ts';
import { Price } from './price.model';
import { ReferencePrice } from '~shared/models/product-card/reference-price.model';
import { ModelMetadataSerializer } from 'serialize-ts/dist/serializers/model-metadata.serializer';

@Model()
export class UnitPrice {
  @Field()
  @Type(new ModelMetadataSerializer(Price))
  price: Price;

  @Field()
  referencePrice: ReferencePrice;

  @Field()
  unitCount: number;
}
